/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Eventscalendarmore2Inputs */

const en_eventscalendarmore2 = /** @type {(inputs: Eventscalendarmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} more`)
};

const de_eventscalendarmore2 = /** @type {(inputs: Eventscalendarmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} weitere`)
};

/**
* | output |
* | --- |
* | "+{count} more" |
*
* @param {Eventscalendarmore2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventscalendarmore2 = /** @type {((inputs: Eventscalendarmore2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventscalendarmore2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventscalendarmore2(inputs)
	return de_eventscalendarmore2(inputs)
});
export { eventscalendarmore2 as "eventsCalendarMore" }